import React from 'react';
import LoanCalculator from '../components/LoanCalculator';

const LoanCalc = () => {
    return (
        <div>
            <LoanCalculator />
        </div>
    );
};

export default LoanCalc;